import { Injectable } from '@angular/core';
import { DataApiService } from '../Services/data-api.service';


@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private url = this.dataApi.url;

  private iss={
    login:  `${this.url}/login`,
    signup : `${this.url}/signup`,
    signupEmpresa : `${this.url}/signupEmpresa`   
  };

  constructor(
    private dataApi:DataApiService,
  ) { }

  handle(token,tipo_usuario,convenio){
    this.set(token,tipo_usuario,convenio);           
  }

  set(token,tipo_usuario,convenio){
    localStorage.setItem("token",token); 
    localStorage.setItem("type",tipo_usuario); 
    localStorage.setItem("convenio",convenio);
  }

  get(){
    localStorage.getItem('token');   
    localStorage.getItem('type');
    localStorage.getItem('convenio');
  }

  remove(){
    localStorage.removeItem("token"); 
    localStorage.removeItem("type");   
    localStorage.removeItem("convenio");  
  }

  isValid(){
    const token = localStorage.getItem('token');

    if(token){
      const payload = this.payload(token);
      if(payload){  
        return Object.values(this.iss).indexOf(payload.iss)>-1  ? true : false;
      }     
    }   
    return false;
  }
  payload(token){
    const payload = token.split('.')[1];
    return this.decode(payload);
  }

  decode(payload){
    return JSON.parse(atob(payload));
  }
 
  loggedIn(){
    return this.isValid();
  }
}
